import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IAppointment, IBooking, ICreateAppointmentResponse, IMumRequested } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-appointment-modal',
  templateUrl: './appointment-modal.component.html',
  styleUrls: ['./appointment-modal.component.scss']
})
export class AppointmentModalComponent implements OnInit {

  @Input() signedUpMum: Array<IMumRequested>;
  @Input() appointmentDate: Date;
  description: string = '';
  selectedMum: any;
  @Output() refresh = new EventEmitter();

  constructor(private snackBar:SnackbarService, private dashBoardService: DashboardService) { }

  ngOnInit(): void {
  }

  selectMum(mum: IMumRequested){
    this.selectedMum = mum;
  }

  createAppointment(){
    let date = this.appointmentDate.getDate();
    this.appointmentDate.setDate(date + 1);

    let body = {
      mumId: this.selectedMum.mumId,
      date: this.appointmentDate.toISOString().split('T')[0],
      description: this.description
    }

    this.dashBoardService.createAppointmentRequest(body)
    .subscribe((res: ICreateAppointmentResponse)=>{
      this.clearData();
      this.refresh.emit(res.payload);
      console.log("Appointment created successfully !", res.payload);
      this.snackBar.openSnackBar("Appointment created successfully !");
    },err=>{
      console.error("Appointment Creation Failed:", err);
    });
  }

  clearData(){
    this.selectedMum = undefined;
    this.description = '';
  }
}
